export const DETAIL_CALENDAR_API_URL = '/api/calendar/economic/detail'
export const ECONOMIC_CALENDAR_API_URL = '/api/calendar/economic'
export const ECONOMIC_CALENDAR_SET_ALERT_API_URL = '/api/calendar/economic/set-alert'
export const EARNINGS_CALENDAR_API_URL = '/api/calendar/earnings'
export const DIVIDENDS_CALENDAR_API_URL = '/api/calendar/dividends'
export const ECONOMIC_CALENDAR_BASE_URL = '/calendar/economic'
export const ISO_DATEONLY_FORMAT = 'yyyy-MM-dd'
export const DATE_FORMAT = 'MMM dd, yyyy'

export enum CalendarView {
  Economic = 'economic',
  EconomicDetail = 'economic/detail',
  Earnings = 'earnings',
  Dividends = 'dividends',
}

export enum CalendarViewParam {
  // NOTE: index
  DateFrom = 'dateFrom',
  // NOTE: detail
  Ticker = 'ticker',

  // NOTE: earnings / dividends
  Sort = 'sort',
  Page = 'page',
}

export interface CalendarViewsParams {
  [CalendarView.Economic]: {
    [CalendarViewParam.DateFrom]: Date
  }
  [CalendarView.EconomicDetail]: {
    [CalendarViewParam.Ticker]: string | undefined
    [CalendarViewParam.DateFrom]: Date
  }
  [CalendarView.Earnings]: {
    [CalendarViewParam.DateFrom]: Date
    [CalendarViewParam.Page]: number
    [CalendarViewParam.Sort]?: string
  }
  [CalendarView.Dividends]: {
    [CalendarViewParam.DateFrom]: Date
    [CalendarViewParam.Page]: number
    [CalendarViewParam.Sort]?: string
  }
}

export const CalendarViewHasParams: Record<CalendarView, CalendarViewParam[]> = {
  [CalendarView.Economic]: [CalendarViewParam.DateFrom],
  [CalendarView.EconomicDetail]: [CalendarViewParam.Ticker, CalendarViewParam.DateFrom],
  [CalendarView.Earnings]: [CalendarViewParam.DateFrom, CalendarViewParam.Sort, CalendarViewParam.Page],
  [CalendarView.Dividends]: [CalendarViewParam.DateFrom, CalendarViewParam.Sort, CalendarViewParam.Page],
}

export const CALENDAR_VIEW_LABELS = {
  [CalendarView.Economic]: 'Economic',
  [CalendarView.Earnings]: 'Earnings',
  [CalendarView.Dividends]: 'Dividends',
}

export enum HistoryFrequency {
  Daily = 0,
  Monthly = 1,
  Weekly = 2,
  Quarterly = 3,
}

export const DETAIL_CHART_BIG_BAR_CATEGORY_GAP = 20
export const DETAIL_CHART_BIG_THRESHOLD = 15
export const DETAIL_CHART_HEIGHT = 250
export const DETAIL_CHART_LINE_CHART_THRESHOLD = 52
export const DETAIL_CHART_SMALL_BAR_CATEGORY_GAP = 3
export const DETAIL_CHART_SMALL_BAR_GAP = 1
